<template>
  <div v-if="isEditable || statement.meta.references.length" class="w3-theme-light">
    <references 
      v-bind:label="'Sources'"
      v-bind:references="statement.meta.references" 
      v-bind:isEditable="isEditable"
      v-bind:model="statement"
      v-on:addReference="addStatementReference()"
      v-on:removeReference="removeStatementReference($event)"
    />
  </div>
</template>

<script>
  import StatementReferences from "./StatementReferences.ts";

  export default StatementReferences;
</script>
